module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_5-4f1f7622dce264a4f0bc61eb70e70e09.svg";